import { render, staticRenderFns } from "./Gallery8.vue?vue&type=template&id=53015982&scoped=true&"
import script from "./Gallery8.vue?vue&type=script&lang=js&"
export * from "./Gallery8.vue?vue&type=script&lang=js&"
import style0 from "./Gallery8.vue?vue&type=style&index=0&id=53015982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53015982",
  null
  
)

export default component.exports